import { CurbyHeader } from '@/components/curby-header';
import { usePrizeEntryCount } from '@/hooks/use-prize-entry-count';
import { Box, Flex, Text, Title } from '@mantine/core';
import { BilbyImage } from './bilbyImage';
import styles from './styles.module.css';

export const Header = () => {
	const { monthlyCount, yearlyCount, loading } = usePrizeEntryCount();

	const title = loading ? null : (
		<>
			<Title order={1}>
				{monthlyCount === 0 ? 'Lots of prizes to win!' : `${monthlyCount} Monthly entries`}
			</Title>
		</>
	);

	const subtitle =
		loading || yearlyCount === 0 ? null : (
			<Text className={styles.subtitle}>{yearlyCount} Yearly entries</Text>
		);

	return (
		<>
			<CurbyHeader>
				<Flex direction="column" className={styles.entries}>
					{title}
					{subtitle}
				</Flex>
				<Box w={158} />
				<BilbyImage className={styles.bilby} />
			</CurbyHeader>
		</>
	);
};
